import {v} from "cst2";
import {Key as ReactKey, ReactNode} from "react";

import {Types} from "../types";

import {cs}        from "./chain-services";
import {fragments} from "./fragments";
import {Invoke}    from "./invoke";
import {keyed}     from "./keyed";
import {UseState}  from "./use-state";

export const Load2 = <Response,>({
    _key=undefined,
    captureException=false,
    disabled = false,
    fetch=undefined,
    keepOutdatedValue=false,
    next,
    onLoad,
}:{
    _key              ?: ReactKey | boolean,
    captureException  ?: boolean,
    disabled          ?: boolean,
    keepOutdatedValue ?: boolean,
    next               : (v:Types.Common.React.Load2.Load2Next<Response>) => ReactNode,
    fetch             ?: () => Promise<Response>,
    onLoad            ?: (loaded:Response) => void,
}) => cs(
    ["loaded", (_, next) => UseState({next})],
    ({loaded}) => {
        const loading = loaded.value == null || loaded.value.key !== _key;

        // if (debug) {
        //     console.log({loading, disabled});
        // }
        return fragments(
            loading && !disabled && cs(
                keyed(_key),
                () => Invoke({
                    onMounted: async ({isMounted}) => {

                        try {
                            const value = await fetch();
                            if (!isMounted()) {
                                return;
                            }
                            loaded.onChange({value, key: _key}, () => onLoad?.(value));
                        } catch (exception) {
                            // console.log("exception", exception);
                            if (!isMounted()) {
                                return;
                            }

                            if (captureException) {
                                loaded.onChange({exception, key: _key}, () => onLoad?.(exception));
                            } else {
                                throw exception;
                            }
                        }

                    },
                })
            ),

            next({
                loading: !disabled && loading,
                // value: loading ? undefined : loaded.value?.value,
                value: !loaded.value || _key !== loaded.value.key && !keepOutdatedValue ? undefined : loaded.value.value,
                exception: loading ? undefined : loaded.value?.exception,
                onChange: (value) => loaded.onChange({
                    key: _key,
                    value,
                }),
                change: (fn) => loaded.change((_) => ({
                    key: _key,
                    value: fn(_.value),
                })),
                reload: async () => {
                    const value = await fetch();
                    loaded.onChange({value, key: _key}, () => onLoad?.(value));
                    return value;
                },
                reset: async () => {
                    loaded.onChange(null);
                },
            }),
        );
    },
);
